import { TextField, TextFieldProps, styled } from '@mui/material';

export const CustomInput = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
  '& input': {
    borderRadius: '8px',
    padding: '10px 14px',
    '&::placeholder': {
      fontFamily: 'Be VietNam Pro',
      color: 'var(--Gray-400, #98A2B3)',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
    },
    '&:not(:placeholder-shown)': {
      fontFamily: 'Be VietNam Pro',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
    },
  },
  margin: '0 !important',
  textAlign: 'left',
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    color: 'var(--Error-700, #B42318)',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      border: '2px solid #B3B3B3',
    },
  },
}));
